<template>
  <div v-if="Object.keys(allData).length" class="report-14" dir="rtl">
    <div class="report-container" v-for="(item, i) in allData.items" :key="i">
      <img v-if="i == 0" class="report-logo" src="/img/ns.png" alt="" />
      <header v-if="i == 0">
        <div class="titlee">
          <h2 class="text-center">
            {{ name }}
          </h2>
          <h3 class="text-center">
            {{ desc }}
          </h3>
        </div>
        <h3 class="main-title">( حافظة ارفاق صك بمرتبات موظفين )</h3>
        <h4 class="dates">
          تاريخ الطباعة :
          <span class="display: inline-block">{{ date }}</span>
        </h4>
      </header>
      <div class="second" v-if="i == 0">
        <p>نوع المعاملة</p>
        <p>مرتبات الموظفين</p>
      </div>
      <div class="third" v-if="i == 0">
        <span style="display: inline-block"
          >نرفقك لكم بهذا الصك رقم : ...................................</span
        >
        <span style="display: inline-block; margin-right: 15px"
          >بتاريخ: ..................................</span
        >
        <span style="display: inline-block; margin-right: 10px">20ف</span>
        <span style="display: inline-block; margin-right: 10px">بمبلغ: </span>
        <span style="display: inline-block; margin-right: 10px">{{
          allData.totalNetSalaries
        }}</span>
      </div>
      <div class="forth" v-if="i == 0">
        <div class="one">
          <p>
            وهو عبارة عن مرتبات الموظفين. يرجى قيد القيمة لحساباتهم المفتوحة
            لديكم وفقا للبيانات المدرجة فيما يلى
          </p>
          <div class="form">
            <p>رقم الاستمارة : .......................................</p>
            <p>شهر : {{ month }}</p>
          </div>
        </div>
        <div class="two">
          <p>إجمالى الصرف</p>
          <p>{{ formatValues(allData.totalNetSalaries) }}</p>
        </div>
      </div>
      <section class="report-14-body">
        <div class="t-head" v-if="i == 0">
          <p>الرقم المالى</p>
          <p>الرقم الوطنى</p>
          <p>إسم الموظف</p>
          <p>رقم الحساب</p>
          <p>صافى المرتبات</p>
        </div>
        <div class="t-body">
          <p>{{ item.financialNumber }}</p>
          <p>{{ item.nationalNumber }}</p>
          <p>{{ item.employeeName }}</p>
          <p>{{ item.accountNumber }}</p>
          <div>
            <p>{{ item.netSalary }}</p>
            <p>د.ل</p>
          </div>
        </div>
      </section>
      <section class="report-14-footer" v-if="i + 1 == allData.items.length">
        <p>عدد المرتبات بالحافظة = {{ allData.items.length }}</p>
        <p>مجموع الحافظة = {{ allData.totalNetSalaries }}</p>
        <p>دينار ليبى</p>
      </section>
      <section class="manger" v-if="i + 1 == allData.items.length">
        <p>رئيس قسم الحسابات</p>
        <p>المراجعة الداخلية</p>
        <p>المراقب المالى</p>
      </section>

      <section class="last" v-if="i + 1 == allData.items.length">
        <p>رقم الصك : ...................</p>
        <p>مجموع الصفحة = {{ allData.totalNetSalaries }}</p>
        <p>دينار ليبى</p>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  props: ["month", "date", "name", "desc", "allData"],
  mounted() {
    // this.loopp();
    // this.allData.items.push(...this.items);
  },
  data() {
    return {
      items: [
        {
          nationalNumber: "119830268666",
          employeeName: "عاصم عربي حبيل كرناص",
          accountNumber: "022.368667.001",
          netSalary: 1170,
        },
        {
          nationalNumber: "119830268666",
          employeeName: "عاصم عربي حبيل كرناص",
          accountNumber: "022.368667.001",
          netSalary: 1170,
        },
        {
          nationalNumber: "119830268666",
          employeeName: "عاصم عربي حبيل كرناص",
          accountNumber: "022.368667.001",
          netSalary: 1170,
        },
        {
          nationalNumber: "119830268666",
          employeeName: "عاصم عربي حبيل كرناص",
          accountNumber: "022.368667.001",
          netSalary: 1170,
        },
        {
          nationalNumber: "119830268666",
          employeeName: "عاصم عربي حبيل كرناص",
          accountNumber: "022.368667.001",
          netSalary: 1170,
        },
        {
          nationalNumber: "119830268666",
          employeeName: "عاصم عربي حبيل كرناص",
          accountNumber: "022.368667.001",
          netSalary: 1170,
        },
        {
          nationalNumber: "119830268666",
          employeeName: "عاصم عربي حبيل كرناص",
          accountNumber: "022.368667.001",
          netSalary: 1170,
        },
        {
          nationalNumber: "119830268666",
          employeeName: "عاصم عربي حبيل كرناص",
          accountNumber: "022.368667.001",
          netSalary: 1170,
        },
        {
          nationalNumber: "119830268666",
          employeeName: "عاصم عربي حبيل كرناص",
          accountNumber: "022.368667.001",
          netSalary: 1170,
        },
        {
          nationalNumber: "119830268666",
          employeeName: "عاصم عربي حبيل كرناص",
          accountNumber: "022.368667.001",
          netSalary: 1170,
        },
        {
          nationalNumber: "119830268666",
          employeeName: "عاصم عربي حبيل كرناص",
          accountNumber: "022.368667.001",
          netSalary: 1170,
        },
        {
          nationalNumber: "119830268666",
          employeeName: "عاصم عربي حبيل كرناص",
          accountNumber: "022.368667.001",
          netSalary: 1170,
        },
        {
          nationalNumber: "119830268666",
          employeeName: "عاصم عربي حبيل كرناص",
          accountNumber: "022.368667.001",
          netSalary: 1170,
        },
        {
          nationalNumber: "119830268666",
          employeeName: "عاصم عربي حبيل كرناص",
          accountNumber: "022.368667.001",
          netSalary: 1170,
        },
        {
          nationalNumber: "119830268666",
          employeeName: "عاصم عربي حبيل كرناص",
          accountNumber: "022.368667.001",
          netSalary: 1170,
        },
        {
          nationalNumber: "119830268666",
          employeeName: "عاصم عربي حبيل كرناص",
          accountNumber: "022.368667.001",
          netSalary: 1170,
        },
        {
          nationalNumber: "119830268666",
          employeeName: "عاصم عربي حبيل كرناص",
          accountNumber: "022.368667.001",
          netSalary: 1170,
        },
        {
          nationalNumber: "119830268666",
          employeeName: "عاصم عربي حبيل كرناص",
          accountNumber: "022.368667.001",
          netSalary: 1170,
        },
        {
          nationalNumber: "119830268666",
          employeeName: "عاصم عربي حبيل كرناص",
          accountNumber: "022.368667.001",
          netSalary: 1170,
        },
        {
          nationalNumber: "119830268666",
          employeeName: "عاصم عربي حبيل كرناص",
          accountNumber: "022.368667.001",
          netSalary: 1170,
        },
        {
          nationalNumber: "119830268666",
          employeeName: "عاصم عربي حبيل كرناص",
          accountNumber: "022.368667.001",
          netSalary: 1170,
        },
        {
          nationalNumber: "119830268666",
          employeeName: "عاصم عربي حبيل كرناص",
          accountNumber: "022.368667.001",
          netSalary: 1170,
        },
        {
          nationalNumber: "119830268666",
          employeeName: "عاصم عربي حبيل كرناص",
          accountNumber: "022.368667.001",
          netSalary: 1170,
        },
        {
          nationalNumber: "119830268666",
          employeeName: "عاصم عربي حبيل كرناص",
          accountNumber: "022.368667.001",
          netSalary: 1170,
        },
        {
          nationalNumber: "119830268666",
          employeeName: "عاصم عربي حبيل كرناص",
          accountNumber: "022.368667.001",
          netSalary: 1170,
        },
        {
          nationalNumber: "119830268666",
          employeeName: "عاصم عربي حبيل كرناص",
          accountNumber: "022.368667.001",
          netSalary: 1170,
        },
        {
          nationalNumber: "119830268666",
          employeeName: "عاصم عربي حبيل كرناص",
          accountNumber: "022.368667.001",
          netSalary: 1170,
        },
        {
          nationalNumber: "119830268666",
          employeeName: "عاصم عربي حبيل كرناص",
          accountNumber: "022.368667.001",
          netSalary: 1170,
        },
        {
          nationalNumber: "119830268666",
          employeeName: "عاصم عربي حبيل كرناص",
          accountNumber: "022.368667.001",
          netSalary: 1170,
        },
        {
          nationalNumber: "119830268666",
          employeeName: "عاصم عربي حبيل كرناص",
          accountNumber: "022.368667.001",
          netSalary: 1170,
        },
        {
          nationalNumber: "119830268666",
          employeeName: "عاصم عربي حبيل كرناص",
          accountNumber: "022.368667.001",
          netSalary: 1170,
        },
        {
          nationalNumber: "119830268666",
          employeeName: "عاصم عربي حبيل كرناص",
          accountNumber: "022.368667.001",
          netSalary: 1170,
        },
        {
          nationalNumber: "119830268666",
          employeeName: "عاصم عربي حبيل كرناص",
          accountNumber: "022.368667.001",
          netSalary: 1170,
        },
        {
          nationalNumber: "119830268666",
          employeeName: "عاصم عربي حبيل كرناص",
          accountNumber: "022.368667.001",
          netSalary: 1170,
        },
        {
          nationalNumber: "119830268666",
          employeeName: "عاصم عربي حبيل كرناص",
          accountNumber: "022.368667.001",
          netSalary: 1170,
        },
        {
          nationalNumber: "119830268666",
          employeeName: "عاصم عربي حبيل كرناص",
          accountNumber: "022.368667.001",
          netSalary: 1170,
        },
        {
          nationalNumber: "119830268666",
          employeeName: "عاصم عربي حبيل كرناص",
          accountNumber: "022.368667.001",
          netSalary: 1170,
        },
        {
          nationalNumber: "119830268666",
          employeeName: "عاصم عربي حبيل كرناص",
          accountNumber: "022.368667.001",
          netSalary: 1170,
        },
        {
          nationalNumber: "119830268666",
          employeeName: "عاصم عربي حبيل كرناص",
          accountNumber: "022.368667.001",
          netSalary: 1170,
        },
        {
          nationalNumber: "119830268666",
          employeeName: "عاصم عربي حبيل كرناص",
          accountNumber: "022.368667.001",
          netSalary: 1170,
        },
        {
          nationalNumber: "119830268666",
          employeeName: "عاصم عربي حبيل كرناص",
          accountNumber: "022.368667.001",
          netSalary: 1170,
        },
        {
          nationalNumber: "119830268666",
          employeeName: "عاصم عربي حبيل كرناص",
          accountNumber: "022.368667.001",
          netSalary: 1170,
        },
        {
          nationalNumber: "119830268666",
          employeeName: "عاصم عربي حبيل كرناص",
          accountNumber: "022.368667.001",
          netSalary: 1170,
        },
        {
          nationalNumber: "119830268666",
          employeeName: "عاصم عربي حبيل كرناص",
          accountNumber: "022.368667.001",
          netSalary: 1170,
        },
        {
          nationalNumber: "119830268666",
          employeeName: "عاصم عربي حبيل كرناص",
          accountNumber: "022.368667.001",
          netSalary: 1170,
        },
        {
          nationalNumber: "119830268666",
          employeeName: "عاصم عربي حبيل كرناص",
          accountNumber: "022.368667.001",
          netSalary: 1170,
        },
        {
          nationalNumber: "119830268666",
          employeeName: "عاصم عربي حبيل كرناص",
          accountNumber: "022.368667.001",
          netSalary: 1170,
        },
        {
          nationalNumber: "119830268666",
          employeeName: "عاصم عربي حبيل كرناص",
          accountNumber: "022.368667.001",
          netSalary: 1170,
        },
        {
          nationalNumber: "119830268666",
          employeeName: "عاصم عربي حبيل كرناص",
          accountNumber: "022.368667.001",
          netSalary: 1170,
        },
        {
          nationalNumber: "119830268666",
          employeeName: "عاصم عربي حبيل كرناص",
          accountNumber: "022.368667.001",
          netSalary: 1170,
        },
        {
          nationalNumber: "119830268666",
          employeeName: "عاصم عربي حبيل كرناص",
          accountNumber: "022.368667.001",
          netSalary: 1170,
        },
        {
          nationalNumber: "119830268666",
          employeeName: "عاصم عربي حبيل كرناص",
          accountNumber: "022.368667.001",
          netSalary: 1170,
        },
        {
          nationalNumber: "119830268666",
          employeeName: "عاصم عربي حبيل كرناص",
          accountNumber: "022.368667.001",
          netSalary: 1170,
        },
        {
          nationalNumber: "119830268666",
          employeeName: "عاصم عربي حبيل كرناص",
          accountNumber: "022.368667.001",
          netSalary: 1170,
        },
        {
          nationalNumber: "119830268666",
          employeeName: "عاصم عربي حبيل كرناص",
          accountNumber: "022.368667.001",
          netSalary: 1170,
        },
        {
          nationalNumber: "119830268666",
          employeeName: "عاصم عربي حبيل كرناص",
          accountNumber: "022.368667.001",
          netSalary: 1170,
        },
        {
          nationalNumber: "119830268666",
          employeeName: "عاصم عربي حبيل كرناص",
          accountNumber: "022.368667.001",
          netSalary: 1170,
        },
        {
          nationalNumber: "119830268666",
          employeeName: "عاصم عربي حبيل كرناص",
          accountNumber: "022.368667.001",
          netSalary: 1170,
        },
        {
          nationalNumber: "119830268666",
          employeeName: "عاصم عربي حبيل كرناص",
          accountNumber: "022.368667.001",
          netSalary: 1170,
        },
        {
          nationalNumber: "119830268666",
          employeeName: "عاصم عربي حبيل كرناص",
          accountNumber: "022.368667.001",
          netSalary: 1170,
        },
        {
          nationalNumber: "119830268666",
          employeeName: "عاصم عربي حبيل كرناص",
          accountNumber: "022.368667.001",
          netSalary: 1170,
        },
        {
          nationalNumber: "119830268666",
          employeeName: "عاصم عربي حبيل كرناص",
          accountNumber: "022.368667.001",
          netSalary: 1170,
        },
        {
          nationalNumber: "119830268666",
          employeeName: "عاصم عربي حبيل كرناص",
          accountNumber: "022.368667.001",
          netSalary: 1170,
        },
        {
          nationalNumber: "119830268666",
          employeeName: "عاصم عربي حبيل كرناص",
          accountNumber: "022.368667.001",
          netSalary: 1170,
        },
        {
          nationalNumber: "119830268666",
          employeeName: "عاصم عربي حبيل كرناص",
          accountNumber: "022.368667.001",
          netSalary: 1170,
        },
      ],
      methods: {
        // loopp() {
        //   console.warn("test loop");
        //   // for (let i = 0; i < 53; i++) {
        //   //   this.allData.items.push(...this.items);
        //   // }
        // },
      },
    };
  },
  methods: {
    formatValues(value) {
      if (!value) {
        return value;
      }
      return value.toLocaleString();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../assets/css/report-14";
</style>
